/* eslint-disable jsx-a11y/interactive-supports-focus */
import cls from 'classnames';
import { i18n } from 'next-i18next';
import Image from 'next/image';
import React from 'react';

import loadingIcon from '@public/imgs/loading.svg';

import styles from './style.module.scss';
export enum TypeButton {
  RED = 'red',
  PRIMARY = 'primary',
  DEFAULT = 'default',
  CANCEL = 'cancel',
}

interface TraceProps {
  dataExposeEvent?: string;
  dataExposeData?: string;
}
interface Props extends TraceProps {
  type?: `${TypeButton}`;
  className?: string;
  processing?: boolean;
  text: string | JSX.Element;
  loading?: boolean;
  onClick?: () => void;
}
const NewButton = (props: Props) => {
  const {
    className,
    processing = false,
    type = TypeButton.DEFAULT,
    text,
    loading,
    onClick,
    dataExposeEvent,
    dataExposeData,
  } = props;

  return (
    <span
      role="button"
      data-expose-event={dataExposeEvent}
      data-expose-data={dataExposeData}
      className={cls(
        styles.button,
        i18n?.language === 'zh' && styles.zh,
        // { [styles.processing]: processing },
        { [styles.default]: type === TypeButton.DEFAULT },
        { [styles.redType]: type === TypeButton.RED },
        { [styles.primary]: type === TypeButton.PRIMARY },
        { [styles.cancel]: type === TypeButton.CANCEL },
        className,
      )}
      onClick={onClick}>
      {loading && (
        <div className={styles.loading}>
          <Image width={24} src={loadingIcon} />
        </div>
      )}
      {processing && (
        <img
          className="mr-[4px] h-[12px] w-[12px]"
          src="/imgs/pc/processing-icon.gif"
          alt="processing"
          onError={e => {
            (e.target as HTMLImageElement).style.display = 'none';
          }}
        />
      )}
      {text}
    </span>
  );
};

export default NewButton;
